import { ClockCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ModalSwitcher from '../common/ModalSwitcher';

const OpenShiftLanding: FC = () => {
  const { t } = useTranslation();
  const modalRef = useRef<any>(null);

  const handleOpenShift = () => {
    modalRef.current?.openModal(true, 'START_SHIFT');
  };

  return (
    <div className="flex flex-col items-center justify-center h-full gap-4">
      <ClockCircleOutlined className="text-[80px] text-gray-400" />
      <div className="flex flex-col items-center gap-1.5">
        <span className="text-sm font-semibold text-gray-500">{t('common:open_shift_title')}</span>
        <span className="text-sm font-semibold text-gray-500">{t('common:open_shift_desc')}</span>
      </div>
      <Button
        type="primary"
        size="large"
        className="min-w-[140px] h-10 text-sm font-medium capitalize"
        onClick={handleOpenShift}
      >
        {t('common:open_shift_btn_title')}
      </Button>
      <ModalSwitcher ref={modalRef} />
    </div>
  );
};

export default OpenShiftLanding;
